<div class="popup modal-header d-inline-block  pb-0 w-100 m-auto">



    <div class="p-4 " >
      <!-- <div class="text-right w-100" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div> -->
      <div class="d-flex justify-content-center align-items-center">
        <img src="assets/images/Success.gif" class="success">
      </div>
      <h1 class="text-center mx-auto">{{data.title}}</h1>
      <p class="mb-5 text-center">{{data.subtitle}}
      </p>
      <div class="mb-4 d-flex  gap-3 resend">
        <button class="btn btn-resend w-100 " (click)="close()">Done</button>
      </div>
    </div>
  </div>
